export const font_family_heading = "Oswald";
export const font_family_playfair = "Playfair";
export const font_family_aksana = "Aksana";
export const font_family_body = "SourceSans";

// export const font_family_bodyRegular = "SourceSans-Regular";
// export const font_family_bodySemibold = "SourceSans-SemiBold";
// export const font_family_bodyBold = "SourceSans-Bold";
// export const font_family_bodyBlack = "SourceSans-Black";
